export const getNextStepDateTime = (step, date = new Date()) => {
  date = date ?? new Date();
  const formattedDate = typeof date === 'string' ? new Date(date) : date;
  const stepMs = 1000 * 60 * step; // convert minutes to ms
  const processedDate = new Date(Math.ceil(formattedDate.getTime() / stepMs) * stepMs);
  return processedDate;
};
